module.exports = __webpack_public_path__ + "static/media/apartment12.ff67853d.jpg";